export default __webpack_public_path__ + "static/crayfish-2ee91c5cca23e8ceedfcd550169c508f.jpeg";